import { formatAssetLabel, findAssetIdsBySymbol, buildSymbolDropdownOptions } from "./formatAsset";

describe("formatAssetLabel", () => {
  it("returns '-' when asset is missing", () => {
    expect(formatAssetLabel(undefined, undefined)).toBe("-");
    expect(formatAssetLabel(null, null)).toBe("-");
  });

  it("returns bare token when chain is missing", () => {
    expect(formatAssetLabel({ "asset-token": "USD" }, undefined)).toBe("USD");
    expect(formatAssetLabel({ "asset-token": "USD" }, null)).toBe("USD");
  });

  it("returns bare token when chain exists but has no chain-name", () => {
    expect(formatAssetLabel({ "asset-token": "USD" }, {})).toBe("USD");
  });

  it("formats 'TOKEN (Chain)' when both resolve", () => {
    expect(
      formatAssetLabel({ "asset-token": "USDC" }, { "chain-name": "Ethereum" })
    ).toBe("USDC (Ethereum)");
  });
});

describe("findAssetIdsBySymbol", () => {
  const assets = [
    { id: 1, "asset-token": "USDC", "chain-id": 1 },
    { id: 5, "asset-token": "USDC", "chain-id": 2 },
    { id: 9, "asset-token": "ETH", "chain-id": 1 },
  ];

  it("returns all matching ids for a multi-chain symbol", () => {
    expect(findAssetIdsBySymbol("USDC", assets)).toEqual([1, 5]);
  });

  it("returns single-element array for a single-chain symbol", () => {
    expect(findAssetIdsBySymbol("ETH", assets)).toEqual([9]);
  });

  it("returns empty array for unknown symbol", () => {
    expect(findAssetIdsBySymbol("DOGE", assets)).toEqual([]);
  });

  it("returns empty array for null/undefined inputs", () => {
    expect(findAssetIdsBySymbol(null, assets)).toEqual([]);
    expect(findAssetIdsBySymbol("USDC", null)).toEqual([]);
    expect(findAssetIdsBySymbol(undefined, assets)).toEqual([]);
  });
});

describe("buildSymbolDropdownOptions", () => {
  const chainsMap = new Map([
    [1, { id: 1, "chain-name": "Ethereum" }],
    [2, { id: 2, "chain-name": "Polygon" }],
  ]);
  const assets = [
    { id: 1, "asset-token": "USDC", "chain-id": 1 },
    { id: 5, "asset-token": "USDC", "chain-id": 2 },
    { id: 9, "asset-token": "ETH", "chain-id": 1 },
  ];

  it("includes per-chain options for every asset", () => {
    const options = buildSymbolDropdownOptions(assets, chainsMap);
    const labels = options.map((o) => o.label);
    expect(labels).toContain("USDC (Ethereum)");
    expect(labels).toContain("USDC (Polygon)");
    expect(labels).toContain("ETH (Ethereum)");
  });

  it("adds synthetic 'SYMBOL (all chains)' option only for symbols with >= 2 chains", () => {
    const options = buildSymbolDropdownOptions(assets, chainsMap);
    const labels = options.map((o) => o.label);
    expect(labels).toContain("USDC (all chains)");
    expect(labels).not.toContain("ETH (all chains)");
  });

  it("synthetic option's value is the symbol-prefixed marker string", () => {
    const options = buildSymbolDropdownOptions(assets, chainsMap);
    const synthetic = options.find((o) => o.label === "USDC (all chains)");
    expect(synthetic.value).toBe("symbol:USDC");
  });

  it("real per-chain option values are numeric asset ids", () => {
    const options = buildSymbolDropdownOptions(assets, chainsMap);
    const eth = options.find((o) => o.label === "ETH (Ethereum)");
    expect(eth.value).toBe(9);
  });

  it("returns empty array for null/undefined assets", () => {
    expect(buildSymbolDropdownOptions(null, chainsMap)).toEqual([]);
    expect(buildSymbolDropdownOptions(undefined, chainsMap)).toEqual([]);
  });

  it("options are sorted alphabetically by label", () => {
    const options = buildSymbolDropdownOptions(assets, chainsMap);
    const labels = options.map((o) => o.label);
    const sorted = [...labels].sort((a, b) => a.localeCompare(b));
    expect(labels).toEqual(sorted);
  });
});
